import { ShieldCheck, Eye, Heart, Star, Handshake } from "lucide-react";
import Reveal from "@/components/Reveal";

const VALUES = [
  { icon: ShieldCheck, k: "Integrity", v: "We do the right thing." },
  { icon: Eye, k: "Transparency", v: "We believe in open & honest communication." },
  { icon: Heart, k: "Commitment", v: "We are dedicated to your success." },
  { icon: Star, k: "Excellence", v: "We deliver the best." },
  { icon: Handshake, k: "Trust", v: "We build lasting relationships." },
];

export default function OurValues() {
  return (
    <section
      id="our-values"
      data-testid="our-values"
      className="relative bg-[#FAF6EC] text-[#0C1530] py-24 md:py-32 overflow-hidden"
    >
      <div className="pointer-events-none absolute -top-24 right-0 w-[420px] h-[420px] rounded-full bg-[#D4AF37]/12 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-32 -left-20 w-[420px] h-[420px] rounded-full bg-[#0F6B3D]/8 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="text-center">
            <span className="gold-divider text-[11px] tracking-[0.32em] uppercase text-[#B68F1E]">
              Our values
            </span>
            <h2
              data-testid="values-heading"
              className="font-display text-[40px] md:text-[60px] mt-5 leading-[1.05] tracking-tight"
            >
              The <em className="not-italic text-[#B68F1E]">five pillars</em> we live by
            </h2>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5">
          {VALUES.map(({ icon: Icon, k, v }, i) => (
            <Reveal key={k} delay={i * 80}>
              <div
                data-testid={`value-${k.toLowerCase()}`}
                className="group h-full rounded-2xl p-6 text-center bg-white border border-[#0A1F44]/10 hover:border-[#D4AF37]/60 hover:-translate-y-1 transition-all duration-300 shadow-[0_10px_30px_-22px_rgba(10,31,68,0.4)]"
              >
                {/* Emerald-tinted disc */}
                <div className="relative inline-flex items-center justify-center w-16 h-16 mx-auto">
                  <div className="absolute inset-0 rounded-full"
                       style={{ background: "radial-gradient(circle, #0F6B3D 0%, #0B4A29 80%)" }}
                  />
                  <div className="absolute inset-[3px] rounded-full bg-white" />
                  <div className="absolute inset-[6px] rounded-full"
                       style={{ background: "linear-gradient(135deg, #134B2C 0%, #0B4A29 100%)" }}
                  />
                  <Icon size={22} strokeWidth={1.75} className="relative text-[#F0D788]" />
                </div>
                <div className="mt-4 font-display text-base sm:text-lg md:text-xl uppercase tracking-wide text-[#0A1F44] break-words">
                  {k}
                </div>
                <p className="mt-2 text-[#0C1530]/65 text-sm leading-snug">{v}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={300}>
          <div
            data-testid="values-tagline"
            className="mt-12 mx-auto max-w-fit px-6 py-2.5 rounded-full bg-[#0A1F44] text-[#F0D788] text-sm md:text-base font-display tracking-wider uppercase"
          >
            ◆ Your Trust is Our Greatest Asset ◆
          </div>
        </Reveal>
      </div>
    </section>
  );
}
